/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { payMonthlyEuro } from "../assets/pay-monthly-euro";
import { Icon, type IconBaseProps } from "../icon";

export const IconPayMonthlyEuro = (props: IconBaseProps) => <Icon {...props} svg={payMonthlyEuro} />;

IconPayMonthlyEuro.displayName = "IconPayMonthlyEuro";
